
<style>
html {
  background-color: #ddd;
}
p {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}


.light-frame {
  margin-bottom: 16px;
  padding: 0px 16px 8px 16px;
  border: 1px solid #eee;
  box-shadow: none !important;
}

@media only screen and (max-width: 480px) {
  .light-frame {
    margin-bottom: 16px;
    padding: 0px 16px 8px 16px;
    border: 1px solid #eee
  }
}

.centered-child {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: column;
}

.main-container {
  background-color: white; padding: 32px;
  max-width: 800px; width: 100%;
  margin: 0px 0px 64px 0px;
}
@media only screen and (max-width: 480px) {
  .main-container {
    background-color: white; padding: 16px; max-width: 800px; width: 100%;
  }
}

.breadcrumb-container {
  display: flex; flex-direction: row; justify-content: center; align-items: center; padding: 0px; background-color: #333; font-size: 1.1em ; color: #eee
}
.breadcrumb-container div {
  margin: 16px;
}
.breadcrumb-container svg {
  width: 16px;
  height: 32px;
}

@media only screen and (max-width: 800px) {
  .breadcrumb-container {
    font-size: 1em;
  }
  .breadcrumb-container div {
    margin: 8px;
  }
}

@media only screen and (max-width: 600px) {
  .breadcrumb-container {
    display: none;
  }
}

.save-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 0px 32px 0px;
  background-color: #fcfcfc;
  padding: 0px 16px;
  width: 100%;
  min-height: 64px;
  border-bottom: 1px solid #BBDEFB;
}
@media only screen and (max-width: 760px) {
  .save-container {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    padding: 32px 32px 32px 32px;
    margin-bottom: 0px;
    max-width: 800px;
    width: 100%;
    border-top: 1px solid #BBDEFB;
  }

  .save-button {
    margin-left: auto !important;
    margin-right: auto !important;
    width: 260px;
  }

}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .5);
  
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: opacity .3s ease;
}
.modal-wrapper {
  display: block;
}
.modal-container {
  width: 300px;
  min-height: 100px;
  max-height: 80vh;
  margin: 0px auto;
  transition: all .3s ease;
  background-color: white;
}

.staging {
  -webkit-transform:rotateY(180deg);
  -moz-transform:rotateY(180deg);
  -o-transform:rotateY(180deg);
  -ms-transform:rotateY(180deg);
  direction:rtl;
}

.faq-container {
  padding: 0px 32px 16px 32px
}
@media only screen and (max-width: 800px) {
  .faq-container {
    padding: 0px 16px 16px 16px
  }
}
.faq-title {
  display: flex; align-items: flex-start;
}
.faq-item {
  padding: 8px; user-select: none;  cursor: pointer;
}

.faq-plus {
  font-size: 1.2em; font-weight: 500; padding: 0px 8px; color: #2196F3;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateX(10px);
}


</style>

<template>

  <div id="app" v-md-theme="'default'" style="padding-bottom: 240px;">

    <svg style="display:none">
      <symbol id="svg-visafrance-id" viewBox="0, 0, 226, 226">
        <g id="Layer_1">
          <path d="M208.092,139.805 L173.592,172.305 L113.092,160.805 L164.092,139.805 z" fill="#FFFFFF"/>
          <path d="M173.592,172.305 L120.092,186.805 L58.342,220.305 L85.092,191.805 L113.092,160.805 z" fill="#FFFFFF"/>
          <path d="M208.092,139.805 L208.092,153.805 L200.662,146.805 z" fill="#FFFFFF"/>
          <path d="M138.592,77.805 L164.092,139.805 L113.092,160.805 z" fill="#FFFFFF"/>
          <path d="M208.092,139.805 L164.092,139.805 L186.092,130.305 z" fill="#FFFFFF"/>
          <path d="M138.592,77.805 L113.092,160.805 L96.592,36.805 z" fill="#FFFFFF"/>
          <path d="M96.592,36.805 L113.092,160.805 L82.092,130.305 z" fill="#FFFFFF"/>
          <path d="M96.592,36.805 L82.092,130.305 L66.092,57.305 z" fill="#FFFFFF"/>
          <path d="M96.592,36.805 L66.092,57.305 L74.092,14.305 z" fill="#FFFFFF"/>
          <path d="M74.092,14.305 L66.092,57.305 L37.592,5.305 z" fill="#FFFFFF"/>
          <path d="M85.092,191.805 L58.342,220.305 L31.592,202.805 z" fill="#FFFFFF"/>
        </g>
      </symbol>
    </svg>
    <svg style="display:none">
      <symbol id="svg-right-chevron" viewBox="0 0 404.258 404.258">
        <polygon points="138.331,0 114.331,18 252.427,202.129 114.331,386.258 138.331,404.258 289.927,202.129 " fill="currentColor"/>
      </symbol>
    </svg>

    <svg style="display:none">
      <symbol id="svg-star" viewBox="0 0 426.667 426.667">
        <polygon points="213.333,10.441 279.249,144.017 426.667,165.436 320,269.41 345.173,416.226 213.333,346.91
          81.485,416.226 106.667,269.41 0,165.436 147.409,144.017 " fill="currentColor"/>
      </symbol>
    </svg>

    <svg style="display:none">
      <symbol id="svg-star-half" viewBox="0 0 426.667 426.667">
        <path d="m 213.33594,0 0.0215,0.04297 v 336.43751 l -0.0215,-0.0117 -131.8418,69.3164 L 106.66797,258.96876 0,154.99415 147.41992,133.57618 Z"
            fill="currentColor" />
       <path d="m 213.33304,6e-6 0.002,0.002 -65.91602,133.574224 h -0.002 z m 0.0234,0.04688 65.90039,133.529294 147.41016,21.41797 -106.66797,103.97461 25.18359,146.81641 -131.82617,-69.30469 z"
            fill="#cccccc" />
      </symbol>
    </svg>

    <md-toolbar>

      <md-button v-if="displayBackButton" class="md-icon-button" @click="onClickBack()">
        <md-icon>arrow_back</md-icon>
      </md-button>
      <div v-else style="margin: 0px 8px 8px 8px">
        <svg width="40px" height="40px">
            <use xlink:href="#svg-visafrance-id" />
        </svg>
      </div>
      <div class="md-title" style="flex: 1;">Visa To France</div>

      <!--<md-button class="md-icon-button" @click="onClickContact()">
        <md-icon>help</md-icon>
      </md-button>-->
      <md-button class="md-icon-button" @click="onClickHome()">
        <md-icon>home</md-icon>
      </md-button>

    </md-toolbar>

    <div class="breadcrumb-container">
      <div :style="{color: breadcrumb > 0 ? '#eee' : '#555'}">1. Qualification</div>
      <svg :style="{color: breadcrumb > 1 ? '#eee' : '#555'}"><use xlink:href="#svg-right-chevron"/></svg>
      <div :style="{color: breadcrumb > 1 ? '#eee' : '#555'}">2. Payment</div>
      <svg :style="{color: breadcrumb > 2 ? '#eee' : '#555'}"><use xlink:href="#svg-right-chevron"/></svg>
      <div :style="{color: breadcrumb > 2 ? '#eee' : '#555'}">3. Constitution of your file</div>
      <svg :style="{color: breadcrumb > 3 ? '#eee' : '#555'}"><use xlink:href="#svg-right-chevron"/></svg>
      <div :style="{color: breadcrumb > 3 ? '#eee' : '#555'}">4. Reading and mailing</div>
    </div>

    <div style="display: flex; flex-direction: column;">

      <!-- Save Form -->
      <div v-if="displaySave" class="save-container" @click.stop="saveUnfolded = true">
        <div style="text-align: center">
          <span style="font-size: 1.2em; font-weight: 500">Save your answers</span><br/>
          <span v-if="saveUnfolded" style="font-size: 0.8em">Enter your email address and click on save</span>
        </div>
        <md-input-container v-if="saveUnfolded" style="min-width: 260px; margin-left: 32px; margin-right: 32px">
          <md-input type="email" v-model="values.id_user_mail" placeholder="Your e-mail address" @keyup.enter="onSave" @keyup.esc="values.id_user_mail = null"></md-input>
        </md-input-container>
        <md-button v-if="saveUnfolded" class="md-raised md-primary save-button" @click.stop="onSave">Save</md-button>
      </div>



      <div class="centered-child">
        <md-whiteframe md-elevation="1" class="main-container">
          <router-view></router-view>
        </md-whiteframe>
      </div>


      <div v-if="initialized && ($route.name == 'home' || $route.name == 'checkout')" class="centered-child" style="margin-top: 16px">
        <md-whiteframe md-elevation="1" class="main-container faq-container">
          <h3>Need help?</h3>


          <!-- only if Landing and checkout -->
          <div v-if="breadcrumb <= 2" class="light-frame faq-item" @click="show1 = !show1">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>Why should I appeal&nbsp;?</div>
            </div>
            <transition name="fade">
              <div v-if="show1" style="padding: 16px 32px">
              <p>The consulate can refuse your visa application for different reasons. Generally, it means that they have some  <b>doubts about the reason </b>of your stay in France, you do not have enough money to stay in France, doubts about your wish to go back in your country by the end of your trip… </p>
              <p>Most of the time, it is caused by a lack of supporting documents.</p>
              <p>In case of short stay visa, you might have received another document with your refusal which indicates the reason of your refusal. You will find more explications  <a href="https://getmyvisatofrance.com/motifs-refus-visa-france.html">of the reasons here</a>.</p>
              </div>
            </transition>
          </div>

          <div v-if="breadcrumb <= 4" class="light-frame faq-item" @click="show2 = !show2">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>What are the chances of success&nbsp;?</div>
            </div>
            <transition name="fade">
              <div v-if="show2" style="padding: 16px 32px">
                <p>To get a visa, the first step is to make an administrative appeal. It is useful if you need to complete your file quickly. The consulate rarely review the files. If you do not have an answer after 2 months you can consider that your appeal has been refused.</p>
                <p>You also need to appeal to the Appeals Board on Visa Refusals. You will get the answer within 2 months (if there is no answer after 2 months you can consider that your appeal is refused). The board only review 1 out of 3 file, and only 30% get a positive answer. Our success rate is 50%.</p>
                <p>If you have a negative answer from the Appeals Board on Visa Refusals, you still can appeal to the Administrative Court of Nantes. All the files are reviewed and our success rate is about 75%</p>
                <p><b>To sum up : You multiplied by 3 your chances to have a positive appeal with us !</b></p>
              </div>
            </transition>
          </div>

          <!-- only if landing -->
          <div v-if="breadcrumb <= 2" class="light-frame faq-item" @click="show3 = !show3">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>Is it free&nbsp;?</div>
            </div>
            <transition name="fade">
              <div v-if="show3" style="padding: 16px 32px">
                <p>You can appeal by yourself to the Appeals Board on Visa Refusals and to the Administrative Court of Nantes by following this instructions <a href="http://www.ambafrance-ht.org/Refus-de-visa-Comment-saisir-la"></a></p>
                <p>GetMyVisa service is <b>profitable</b> and deliver you some personalised appeal according to your situation. The appeals are reviewed by our experts before being sending back to you after 48 working hours</p>
                <p>Our prices are <b>all-inclusive</b>! and we propose you 2 different rates<br>
                  <ul>
                    <li><b>299€ TTC</b>: You will receive a personalised appeal, you will prepare your file only online , your file will be processed thanks to our tool developed with our lawyers</li>
                    <li><b>999€ TTC</b>: We offer you the possibility to make your file with our lawyers. You will have some online meetings with them. Our lawyers will make all your appeals.</li>
                  </ul>
                </p>
                <p>Normally, an appeal made by a lawyer costs between 1800-2500€ in Paris.</p>
                <p>If your appeal is positive, the French state can pay you back all the fees.</p>
              </div>
            </transition>
          </div>

          <!-- only if Landing and checkout -->
          <div v-if="breadcrumb <= 3" class="light-frame faq-item" @click="show4 = !show4">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>What are the deadlines to appeal&nbsp;?</div>
            </div>
            <transition name="fade">            
              <div v-if="show4" style="padding: 16px 32px">
                <p>GetMyVisa service is <b>profitable</b> and deliver you some personalised appeal according to your situation. The appeals are reviewed by our experts before being sending back to you after 48 working hours</p>
                <p>the Appeals Board on Visa Refusals gives an answer <b>within 2 months</b>. The Administrative Court of Nantes gives an answer <b>within 10 months.</b></p>
                <p>In case of emergency : health problem, special events (wedding, contest), it is possible to get a review of your case <b>within 15 days</b> with a referred procedure. You only can have this service with our Premium Pack because you need the help of our lawyers</p>
              </div>
            </transition>
          </div>

          <!-- only if landing -->
          <div v-if="breadcrumb <= 2" class="light-frame faq-item" @click="show5 = !show5">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>I appealed to the Appeals Board on Visa Refusals but I still de not have answer&nbsp;!</div>
            </div>
            <transition name="fade">
              <div v-if="show5" style="padding: 16px 32px">
                <p> The Appeals Board on Visa Refusals only reviews 1 out of 3 appeals. If you do not have answer <b>within 2 months</b> it means that your appeal has been refused.</b>.
                </p>
                <p> The <b>good news</b> is that you are now able to appeal to the the Administrative Court of Nantes. This administration reviews each appeal. The waiting time is longer but you have more chances to get a positive answer.
                </p>
              </div>
            </transition>
          </div>

          <!-- only if checkout -->
          <div v-if="$route.name == 'checkout'" class="light-frame faq-item" @click="show6 = !show6">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>What guarantees do I have&nbsp;? Am I repaid if I have a refusal&nbsp;?</div>
            </div>
            <transition name="fade">
              <div v-if="show6" style="padding: 16px 32px">
                <p>It’s impossible for us to guarantee the success of your appeal. It depends on different factors like your capacity to get all the documents we ask you and sent it by mail to the administration.</p>
                <p>But you can be sure that you will get a personalised appeal with a list of the documents you need to send. If we are not able to make a personalised appeal you will be refund.</p>
                <p>Moreover, our appeals<b>are reviewed by our lawyers</b></p>
                <p>If your appeal is positive, the French state can pay you back all the all the fees.</p>
              </div>
            </transition>
          </div>

          <!-- only if checkout -->
          <div v-if="breadcrumb == 2" class="light-frame faq-item" @click="show7 = !show7">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>Do I have to pay first&nbsp;?</div>
            </div>
            <transition name="fade">
              <div v-if="show7" style="padding: 16px 32px">
              <p>Yes. You can be sure that you will get your personalised appeal in a few days. If we do not respect our promess you will be paid back.</p>
              <p>Once the payment made, you will ahve access to our tool. If you have all the documents we need, you will receive your appeal within 48 working hours.</p>
              </div>
            </transition>
          </div>

          <!-- only if Home -->
          <div v-if="breadcrumb <= 4" class="light-frame faq-item" @click="show8 = !show8">
            <div class="faq-title">
              <div class="faq-plus">+</div><div>I do not have news for my appeal, what happens&nbsp;?</div>
            </div>
            <transition name="fade">
              <div v-if="show8" style="padding: 16px 32px">
                <p>If you gave us all the documents we asked, you will get your appeal within 48 working hours. As the appeal has to be reviewed by our lawyers, they might be non available for personal issues. <u>You will get your appeal as soon as possible</u>.</p>
                <p>We never forget you !</p>
              </div>
            </transition>
          </div>

        </md-whiteframe>
      </div>

      <div v-if="!initialized"  class="centered-child" style="margin-top: 16px">
        <md-whiteframe md-elevation="1" class="main-container centered-child">
          <p v-if="initializationError">
            We have a problem with our IT server. Our team is repairing the problem.<br>
           You can contact us at <a href="mailto:contact-visa@getmyvisatofrance.com">contact-visa@getmyvisatofrance.com</a> in case of emergency.
          </p>
          <p v-else>
            Please wait, charging in progress.
          </p>
        <br>
        <i v-if="initializationError" class="fa fa-exclamation-triangle" style="font-size:64px; margin-top: 16px; color: #888"></i>
        <i v-else class="fa fa-gear fa-spin" style="font-size:48px; margin-top: 0px; color: #888"></i>
        </md-whiteframe>
      </div>

    </div>
    

    <transition v-if="displayModal" name="modal">
      <div class="modal-mask" @click="onClickCloseModal()">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop.prevent>
            <md-toolbar class="md-dense">
              <h2 class="md-title" style="flex: 2">{{modalTitle}}</h2>

            <md-button class="md-icon-button" @click="onClickCloseModal()" style="padding-right: 0px">
                <md-icon>close</md-icon>
              </md-button>
            </md-toolbar>
            <div class="md-body-2" style="padding: 16px" v-html="modalBody">
            </div>

          </div>
        </div>
      </div>
    </transition>





  </div>
</template>


<script>
import ServiceAccess from './service/ServiceAccess'

export default {

  data: function () {
    return {
      displayModal: false,
      modalTitle: '',
      modalBody: '',

      initialized: false,
      initializationError: false,

      breadcrumb: 0,

      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      show7: false,
      show8: false,

      purchases: null,
      values: null,
      stage: null,
      hasValues: false,
      displayBackButton: false,
      saveUnfolded: window.screen.width >= 600,
      displaySave: false
    }
  },


  watch: {
    '$route' (to, from) {
      ServiceAccess.instance.loadStage(this.$route.params.sessionId).then(stage => {
        this.stage = stage
        this.updateBreadcrumb(to, from)
      })
    }
  },

  updated: function () {
    this.updateBinding()
    if (!this.customVariableSet && this.values && this.values.id_user_mail) {
      this.customVariableSet = true
      if (global.LC_API) {
        global.LC_API.set_custom_variables([{email: this.values.id_user_mail}])
      }
    }
  },

  created: function () {
    global.navigationBarBus.$on('navigation-display-back', this.onDisplayBackButton)
    global.navigationBarBus.$on('info', this.onInfo)
    global.navigationBarBus.$on('display-save', this.onDisplaySave)

    let promises = [
      ServiceAccess.instance.purchases(this.$route.params.sessionId),
      ServiceAccess.instance.loadStage(this.$route.params.sessionId),
      ServiceAccess.instance.loadValues(this.$route.params.sessionId)
    ]
    Promise.all(promises).then(responses => {
      let [purchases, stage, values] = responses
      this.purchases = purchases
      this.stage = stage
      this.values = values

      this.updateBinding()
      this.updateBreadcrumb(this.$route)
      this.initialized = true
    }).catch(err => {
      this.initializationError = true
      console.error('Initilization Error', err)
    })


    if (navigator) {
      ServiceAccess.instance.track(this.$route.params.sessionId, 'navigator', {appName: navigator.appName, appCodeName: navigator.appCodeName, appVersion: navigator.appVersion, language: navigator.language, platform: navigator.platform, userAgent: navigator.userAgent})
      // console.log('UA', navigator.userAgent)
      if (navigator.userAgent.indexOf('MSIE ') > 0 || navigator.userAgent.indexOf('Trident') > 0) {
        this.onInfo('Internet Explorer n\'est pas supporté. Nous vous invitons à utiliser Firefox ou Google Chrome. Merci pour votre compréhension.', 'Erreur')
      }
    }
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-display-back', this.onDisplayBackButton)
    global.navigationBarBus.$off('info', this.onInfo)
  },


  methods: {
    updateBinding: function () {
      this.hasValues = this.values && Object.keys(this.values).length > 0
    },

    updateBreadcrumb: function (to, from) {
      if (to && to.name !== 'home') {
        this.breadcrumb = 1
      }
      if (this.hasValues) {
        this.breadcrumb = 1
      }
      if (this.stage && this.stage.name === 'wait-payment') {
        this.breadcrumb = 2
      }
      if (to && to.name && to.name.startsWith('checkout')) {
        this.breadcrumb = 2
      } 
      if (this.stage && this.stage.name === 'payment-done') {
        this.breadcrumb = 3
      }

      if (this.stage && (this.stage.name === 'in-review' || this.stage.name === 'document-ready')) {
        this.breadcrumb = 4
      }
    },

    onDisplayBackButton: function (v) {
      this.displayBackButton = v
    },

    onClickBack: function () {
      if (!this.$route.params.sessionId.startsWith('@')) {
        global.navigationBarBus.$emit('navigation-back')
      }
    },

    onSave: function () {
      // console.log('this.values.id_user_mail', this.values.id_user_mail)
      this.displaySave = this.values.id_user_mail == null
      this.saveUnfolded = false
      if (this.values.id_user_mail) {
        ServiceAccess.instance.saveUserCase(this.$route.params.sessionId, this.values)
      }
    },

    onClickContact: function () {
      global.LC_API.open_chat_window()

      // window.open('https://lc.chat/now/8514408/', '_blank')
    },

    onClickHome: function () {
      if (!this.$route.params.sessionId.startsWith('@')) {
        this.$router.push('/f/' + this.$route.params.sessionId + '/')
      }
    },

    onInfo: function (info, title = 'Aide') {
      this.modalTitle = title
      this.modalBody = info
      this.displayModal = true
    },

    onDisplaySave: function (displaySave) {
      this.displaySave = displaySave
    },

    onClickCloseModal: function () {
      this.displayModal = false
    }


  }
}
</script>



// WEBPACK FOOTER //
// App.vue?9bdc25c8